var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1221 25.8853H25.7555C25.6242 26.002 25.493 26.1041 25.3617 26.2208L19.1346 30.8874C17.0784 32.4186 13.7242 32.4186 11.6534 30.8874L5.41173 26.2208C4.0409 25.1999 2.91797 22.9395 2.91797 21.2332V10.427C2.91797 8.64781 4.27423 6.67906 5.93673 6.05198L13.1992 3.3249C14.3951 2.87282 16.3784 2.87282 17.5742 3.3249L24.8221 6.05198C26.2076 6.57698 27.3888 8.03532 27.7534 9.52282H17.1075C16.7867 9.52282 16.495 9.53742 16.218 9.53742C13.52 9.69783 12.82 10.6749 12.82 13.752V21.6707C12.8346 25.0249 13.6951 25.8853 17.1221 25.8853Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 16.3623H32.0859",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0859 13.7374V21.8311C32.0568 25.0686 31.1672 25.8707 27.7984 25.8707H17.1234C13.6964 25.8707 12.8359 25.0103 12.8359 21.6415V13.7228C12.8359 10.6603 13.5359 9.68321 16.2339 9.50821C16.5109 9.50821 16.8026 9.49365 17.1234 9.49365H27.7984C31.2255 9.50824 32.0859 10.3541 32.0859 13.7374Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 22.2542H18.4474",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5117 22.2542H26.2805",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCard);
export default __webpack_public_path__ + "static/media/Security-card.27b3721b0bf1546cc69237b99a7d39f1.svg";
export { ForwardRef as ReactComponent };